export function StatsIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M37.106 11.7052V32.1939C37.106 35.0883 34.7594 37.4257 31.8742 37.4257H10.1255C7.24031 37.4257 4.89378 35.0883 4.89378 32.1939V26.25C4.89378 23.3648 7.24031 21.0183 10.1255 21.0183H13.869V20.1965C13.869 17.2383 16.2703 14.837 19.2194 14.837H22.826V11.9609C22.826 8.16262 25.6929 4.83914 29.482 4.59262C33.6273 4.31871 37.106 7.60567 37.106 11.7144V11.7052Z"
        fill="url(#paint0_linear_21268_24271)"
      />
      <path
        d="M13.942 24.6157H10.1346C9.22155 24.6157 8.49112 25.3553 8.49112 26.2592V32.2031C8.49112 33.1162 9.23068 33.8466 10.1346 33.8466H13.942C14.855 33.8466 15.5855 33.107 15.5855 32.2031V26.2592C15.5855 25.3462 14.8459 24.6157 13.942 24.6157Z"
        fill="url(#paint1_linear_21268_24271)"
      />
      <path
        d="M22.7805 18.4253H19.2288C18.2519 18.4253 17.4575 19.2196 17.4575 20.1966V32.0753C17.4575 33.0523 18.2519 33.8466 19.2288 33.8466H22.7805C23.7575 33.8466 24.5519 33.0523 24.5519 32.0753V20.1966C24.5519 19.2196 23.7575 18.4253 22.7805 18.4253Z"
        fill="url(#paint2_linear_21268_24271)"
      />
      <path
        d="M29.9754 8.15356C31.9384 8.15356 33.5271 9.75139 33.5271 11.7053V32.194C33.5271 33.107 32.7967 33.8466 31.8837 33.8466H28.0763C27.1632 33.8466 26.4328 33.1162 26.4328 32.194V11.7053C26.4328 9.74226 28.0306 8.15356 29.9845 8.15356H29.9754Z"
        fill="url(#paint3_linear_21268_24271)"
      />
      <path
        opacity="0.62"
        d="M29.9754 14.2618C28.542 14.2618 27.3824 13.0931 27.3824 11.6687C27.3824 10.2444 28.542 9.07568 29.9754 9.07568C31.4089 9.07568 32.5685 10.2444 32.5685 11.6687C32.5685 13.0931 31.4089 14.2618 29.9754 14.2618Z"
        fill="url(#paint4_linear_21268_24271)"
      />
      <path
        d="M29.9751 13.6958C31.0981 13.6958 32.002 12.7918 32.002 11.6688C32.002 10.5458 31.0981 9.64185 29.9751 9.64185C28.852 9.64185 27.9481 10.5458 27.9481 11.6688C27.9481 12.7918 28.852 13.6958 29.9751 13.6958Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21268_24271"
          x1="16.6994"
          y1="37.3983"
          x2="32.9607"
          y2="6.47349"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00FF00" />
          <stop offset="0.52" stopColor="#00FF00" stopOpacity="0.89" />
          <stop offset="1" stopColor="#99FF00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_21268_24271"
          x1="7.99808"
          y1="43.1414"
          x2="17.4389"
          y2="10.6188"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008800" />
          <stop offset="1" stopColor="#00D400" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_21268_24271"
          x1="15.4397"
          y1="45.2962"
          x2="24.8714"
          y2="12.7827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008800" />
          <stop offset="1" stopColor="#00D400" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_21268_24271"
          x1="22.5706"
          y1="47.3597"
          x2="32.0023"
          y2="14.8462"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008800" />
          <stop offset="1" stopColor="#00D400" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_21268_24271"
          x1="29.9754"
          y1="9.26742"
          x2="29.9754"
          y2="14.5266"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1FD00" stopOpacity="0.8" />
          <stop offset="1" stopColor="#DEFD92" stopOpacity="0.5" />
        </linearGradient>
      </defs>
    </svg>
  )
}
